import script from "./all-notifications.vue?vue&type=script&setup=true&lang=js"
export * from "./all-notifications.vue?vue&type=script&setup=true&lang=js"

import "./all-notifications.vue?vue&type=style&index=0&id=222a23f5&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-222a23f5"]])

export default __exports__